import React, { useEffect, useState, ReactElement } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  TextField,
  Paper,
  MenuItem,
} from "@mui/material";
import { getUserInfo, setHomeTenpoCodeList } from "../../data/userInfo";
import { apiRequest } from "../../apis/util";
import { userAuthCheck, isAdminUser, isAssortmentAnalysisRailwayStoreOnlyUser, isAssortmentAnalysisOwnStoreOnlyUser, isAssortmentAnalysisAllStoreUser, isRailwayDepartmentUser } from "../auth/authUser";
import Header from "../common/Header";

const fixedContainer = css`
  position: fixed;
  top: 70px;
  left: 2vw;
  width: 30%;
  height: calc(100vh - 99px);
  padding-right: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const card = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const buttonContainer = css`
  margin-top: 0.5rem;
`;

const contentContainer = css`
  margin-left: 30%;
  padding-left: 2vw;
  padding-top: 10vh;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const button = css`
  width: 100%;
  height: 100%;
  text-transform: none;
  font-weight: bold;
  padding: 1rem;
  background-color: #00cc5b;
  color: #fff;
  display: block;
  margin: auto;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: #00cc5bb3;
  }
`;

const subButton = css`
  background-color: #e0ffee;
  color: #333;
  &:hover {
    background-color: #cfffe4;
  }
`;

const Home: React.FC<{}> = ({}) => {
  const [allTenpoData, setAllTenpoData] = useState<any[]>([]);
  const [tenpoCodes, setTenpoCodes] = useState<string[]>([]);
  const [doCodes, setDoCodes] = useState<string[]>([]);
  const [selectedTenpoCode, setSelectedTenpoCode] = useState<string>("");
  const [selectedDoCode, setSelectedDoCode] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [showDailyMulti, setShowDailyMulti] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errorAPI, setErrorAPI] = useState(false);
  const userInfo = getUserInfo();

  useEffect(() => {
    let res: any = {};
      if (userInfo) {
        if (isAdminUser(userInfo)) {
          const params = {
            mode: "homeTenpo",
          };
          (async () => {
            try {
              setLoading(true);
              res = await apiRequest(params);
              const responseData = res.data.data.homeTenpoSearchByParams || [];
              setAllTenpoData(responseData);
              // allTenpoDataをsessionStorageに保存
              sessionStorage.setItem("allTenpoData", JSON.stringify(responseData));

              if (responseData.length > 0) {
                const allTenpoCodes = responseData.map(
                  (item: any) => item.tenpo_code
                  );
                setHomeTenpoCodeList(allTenpoCodes);
                setTenpoCodes(allTenpoCodes);
                if (allTenpoCodes.length > 0) {
                  setSelectedTenpoCode(allTenpoCodes[0]);
                }

                const doCodesFromApi = responseData.map(
                  (item: any) => item.do_code
                );
                const uniqueDoCodes = Array.from(
                  new Set<string>(doCodesFromApi)
                ).sort();
                setDoCodes(uniqueDoCodes);
                setSelectedDoCode(""); // "指定なし" をデフォルトに設定
              }
            } catch (e) {
              setAllTenpoData([]);
              setTenpoCodes([]);
              setSelectedTenpoCode("");
              setDoCodes([]);
              setSelectedDoCode("");
              setErrorAPI(true);
            }
            setLoading(false);
          })();
        } else if (isAssortmentAnalysisRailwayStoreOnlyUser(userInfo)) {
          const params = {
            mode: "tetsudouTenpo",
            zo_code: "045",
          };
          (async () => {
            try {
              setLoading(true);
              res = await apiRequest(params);
              const responseData = res.data.data.tetsudouTenpoSearchByParams || [];
              setAllTenpoData(responseData);
              // allTenpoDataをsessionStorageに保存
              sessionStorage.setItem("allTenpoData", JSON.stringify(responseData));

              if (responseData.length > 0) {
                const tetsudouTenpoCodes = responseData.map(
                  (item: any) => item.tenpo_code
                  );
                setHomeTenpoCodeList(tetsudouTenpoCodes);
                setTenpoCodes(tetsudouTenpoCodes);
                if (tetsudouTenpoCodes.length > 0) {
                  setSelectedTenpoCode(tetsudouTenpoCodes[0]);
                }
                const doCodesFromApi = responseData.map(
                  (item: any) => item.do_code
                );
                const uniqueDoCodes = Array.from(
                  new Set<string>(doCodesFromApi)
                ).sort();
                setDoCodes(uniqueDoCodes);
                setSelectedDoCode(""); // "指定なし" をデフォルトに設定
              }
            } catch (e) {
              setAllTenpoData([]);
              setTenpoCodes([]);
              setSelectedTenpoCode("");
              setDoCodes([]);
              setSelectedDoCode("");
              setErrorAPI(true);
            }
            setLoading(false);
          })();
        } else if (isAssortmentAnalysisAllStoreUser(userInfo)) {
          const params = {
            mode: "homeTenpo",
          };
          (async () => {
            try {
              setLoading(true);
              res = await apiRequest(params);
              const responseData = res.data.data.homeTenpoSearchByParams || [];
              setAllTenpoData(responseData);
              // allTenpoDataをsessionStorageに保存
              sessionStorage.setItem("allTenpoData", JSON.stringify(responseData));

              if (responseData.length > 0) {
                const allTenpoCodes = responseData.map(
                  (item: any) => item.tenpo_code
                );
                setHomeTenpoCodeList(allTenpoCodes);
                setTenpoCodes(allTenpoCodes);
                if (allTenpoCodes.length > 0) {
                  setSelectedTenpoCode(allTenpoCodes[0]);
                }

                const doCodesFromApi = responseData.map(
                  (item: any) => item.do_code
                );
                const uniqueDoCodes = Array.from(
                  new Set<string>(doCodesFromApi)
                ).sort();
                setDoCodes(uniqueDoCodes);
                setSelectedDoCode(""); // "指定なし" をデフォルトに設定
              }
            } catch (e) {
              setAllTenpoData([]);
              setTenpoCodes([]);
              setSelectedTenpoCode("");
              setDoCodes([]);
              setSelectedDoCode("");
              setErrorAPI(true);
            }
            setLoading(false);
          })();
        } else {
          const tenpoCodes = userInfo.tenpo_code || [];
          if (tenpoCodes.length > 0) {
            setTenpoCodes(tenpoCodes);
            setSelectedTenpoCode(tenpoCodes[0]);
          }

          const doCodes = userInfo.do_code || [];
          if (doCodes.length > 0) {
            setDoCodes(doCodes);
            setSelectedDoCode(doCodes[0]);
          }
        }
        setShowDailyMulti(userAuthCheck(userInfo, "", "dailyMulti"));
      }
  }, []);

  // 各画面へのリンクを定義
  const allMenuItems = [
    { name: "個店経営状況（個別）サマリ", pathname: "/daily-store-summary" },
    { name: "日別管理表", pathname: "/daily-management" },
    { name: "廃棄検証（PMA）", pathname: "/disposal-verification-pma" },
    { name: "POS-PMA分析_サマリ", pathname: "/pos-analysis-summary" },
    { name: "POS-PMA分析_PMA", pathname: "/pos-analysis-pma" },
    { name: "POS-PMA分析_PMA推移", pathname: "/pos-analysis-transition" },
    { name: "品揃え分析（新上位100単品）", pathname: "/assortment-analysis" },
  ];

  const menuItems = (() => {
    if (process.env.REACT_APP_MODE !== "cloud-prod" &&
        process.env.REACT_APP_MODE !== "cloud-demo") {
      return allMenuItems;
    }
    if (
      isAdminUser(userInfo) ||
      isRailwayDepartmentUser(userInfo)
    ) {
      return allMenuItems;
    }
    if (isAssortmentAnalysisAllStoreUser(userInfo)||
        isAssortmentAnalysisRailwayStoreOnlyUser(userInfo) ||
        isAssortmentAnalysisOwnStoreOnlyUser(userInfo)) {
      return allMenuItems.filter(
        (item) => item.name === "品揃え分析（新上位100単品）"
      );
    }
    return allMenuItems.filter(
      (item) => item.name !== "品揃え分析（新上位100単品）"
    );
  })();

      
  // 画面遷移関数
  const navigateToPage = (pathname: string) => {
    const connector = pathname.includes("?") ? "&" : "?";
    const url = `${pathname}${connector}tenpocode=${selectedTenpoCode}`;
    window.open(url, "_blank");
  };

  // 個店経営状況（サブ）画面遷移関数
  const navigateToSubPage = (pathname: string) => {
    window.open(pathname, "_blank");
  };

  // 店舗コードを選択する関数
  const handleSelectTenpoCode = (code: string) => {
    setSelectedTenpoCode(code);
  };

  // DOコードを選択する関数
  const handleSelectDoCode = (code: string) => {
    setSelectedDoCode(code);

    let filteredTenpos: string[];
    if (code === "") {
      // "指定なし" が選択された場合、すべての店舗コードを表示
      filteredTenpos = allTenpoData.map((item) => item.tenpo_code);
    } else {
      // 特定のDOコードが選択された場合、フィルタリング
      filteredTenpos = allTenpoData
        .filter((item) => item.do_code === code)
        .map((item) => item.tenpo_code);
    }

    setTenpoCodes(filteredTenpos);
    if (filteredTenpos.length > 0) {
      setSelectedTenpoCode(filteredTenpos[0]);
    } else {
      setSelectedTenpoCode("");
    }
  };

  const filteredTenpoCodes = tenpoCodes.filter((code) =>
    code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Header
        windowName="ホーム"
        tenpoCode=""
        tenpoName="OFCダッシュボード"
        showOpview={true}
      />
      <Box css={fixedContainer}>
        <Paper elevation={3} sx={{ p: 2, mb: 2, flexShrink: 0 }}>
          {doCodes.length > 1 ? (
            <TextField
              select
              label="所属DOコード"
              value={selectedDoCode}
              onChange={(e) => handleSelectDoCode(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
            >
              <MenuItem value="">指定なし</MenuItem>
              {doCodes.map((code) => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              所属DOコード : {selectedDoCode}
            </Typography>
          )}
        </Paper>
        <Paper
          elevation={3}
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
          }}
        >
          {/* 店舗コード一覧 */}
          <Box sx={{ flexShrink: 0 }}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
              担当店舗コード一覧
            </Typography>
            <TextField
              label="店番で探す"
              variant="outlined"
              size="small"
              fullWidth
              value={searchTerm}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchTerm(e.target.value)
              }
              sx={{ mb: 2 }}
            />
            <Divider sx={{ mb: 2 }} />
          </Box>
          <Box sx={{ overflowY: "auto", flexGrow: 1 }}>
            {filteredTenpoCodes.length > 0 ? (
              <List>
                {filteredTenpoCodes.map((code, index) => (
                  <div key={code}>
                    <ListItem
                      onClick={() => handleSelectTenpoCode(code)}
                      sx={{
                        cursor: "pointer",
                        bgcolor:
                          selectedTenpoCode === code
                            ? "rgba(25, 118, 210, 0.12)"
                            : "transparent",
                        borderRadius: "4px",
                        fontWeight:
                          selectedTenpoCode === code ? "bold" : "normal",
                      }}
                    >
                      <ListItemText primary={code} />
                    </ListItem>
                    {index < filteredTenpoCodes.length - 1 && <Divider />}
                  </div>
                ))}
              </List>
            ) : (
              <Typography>該当の店舗コードがありません</Typography>
            )}
          </Box>
        </Paper>
      </Box>
      <Box css={contentContainer}>
        <Paper elevation={3} sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
            個店経営状況
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2} css={buttonContainer}>
            {menuItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.name}>
                <Card css={card}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          whiteSpace: "pre-line",
                          wordBreak: "keep-all",
                          lineHeight: "1.5",
                          height: "100%",
                          flexGrow: 1,
                        }}
                        css={button}
                        onClick={() => navigateToPage(item.pathname)}
                      >
                        {item.name}
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
        {showDailyMulti &&
          !isAssortmentAnalysisAllStoreUser(userInfo) &&
          !isAssortmentAnalysisOwnStoreOnlyUser(userInfo) && (
            <Paper elevation={3} sx={{ p: 1, mt: 1 }}>
              <Grid container spacing={2} css={buttonContainer}>
                <Grid item xs={12} sm={6} md={4}>
                <Card css={card}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          whiteSpace: "pre-line",
                          wordBreak: "keep-all",
                          lineHeight: "1.5",
                          height: "100%",
                          flexGrow: 1,
                        }}
                        css={[button, subButton]}
                        onClick={() =>
                          navigateToSubPage(
                            `/daily-store-multi?docode=${selectedDoCode}`
                          )
                        }
                      >
                        個店経営状況（サブ）
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Box>
    </>
  );
};

export default Home;
